"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Flight = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _downshift = _interopRequireDefault(require("downshift"));
var _classnames6 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var R = _interopRequireWildcard(require("ramda"));
var _pluralTranslations = require("../../../../../localization/pluralTranslations");
var _Tooltip = _interopRequireWildcard(require("../../../../ui/Tooltip"));
var _helpers = require("../../PricesMatrix/components/DropdownBody/helpers");
var _styles = _interopRequireDefault(require("../../../styles"));
var _arrow = _interopRequireDefault(require("./img/arrow.svg"));
var _plane = _interopRequireDefault(require("./img/plane.svg"));
var _bus = _interopRequireDefault(require("./img/bus.svg"));
var _train = _interopRequireDefault(require("./img/train.svg"));
var _walk = _interopRequireDefault(require("./img/walk.svg"));
var _styles2 = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getTransportIcon = function getTransportIcon(transport) {
  return R.call(R.cond([[R.equals('air'), R.always(_plane.default)], [R.equals('bus'), R.always(_bus.default)], [R.equals('train'), R.always(_train.default)], [R.equals('no'), R.always(_walk.default)], [R.T, R.F]]), transport);
};
var getIconClassBySeats = R.cond([[function (seats) {
  return R.includes(seats, ['yes', 'many', 'yesplace']);
}, R.always(_styles.default.green)], [function (seats) {
  return R.includes(seats, ['request', 'few']);
}, R.always(_styles.default.yellow)], [R.T, R.always(_styles.default.red)]]);
var mapperWithIndex = R.addIndex(R.map);
var printFlightInformation = function printFlightInformation(flight, isActual, placesTranslation, t) {
  return R.join(' ', R.filter(Boolean, [R.call(R.pipe(R.filter(Boolean), R.ifElse(R.length, function (ports) {
    return R.concat(R.join('-', ports), ' ');
  }, R.always(''))), [flight.portFr, flight.portTo]), flight.line, isActual && flight.place > 0 && flight.seats.value === 'few' && "(".concat(flight.place, " ").concat(placesTranslation(flight.place), ")"), isActual && flight.seats.value === 'yesplace' && "(".concat(t('THERE_ARE_PLACES'), ")"), isActual && !flight.place && flight.seats.value === 'few' && "(".concat(t('FEW_PLACES'), ")")]));
};
var isDateWithoutTime = function isDateWithoutTime(date) {
  return R.call(function (momentDate) {
    return !momentDate.hours() && !momentDate.minutes() && !momentDate.seconds();
  }, (0, _moment.default)(date, 'YYYY-MM-DD HH:mm:ss'));
};
var printFlightDate = function printFlightDate(flight) {
  return isDateWithoutTime(flight.begin) ? null : (0, _moment.default)(flight.begin, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
};
var PureFlight = function PureFlight(_ref) {
  var active = _ref.active,
    compact = _ref.compact,
    flight = _ref.flight,
    isActual = _ref.isActual,
    transport = _ref.transport,
    onClick = _ref.onClick;
  var placesTranslation = (0, _pluralTranslations.usePluralPlacesTranslation)();
  var _useTranslation = (0, _reactI18next.useTranslation)('PLACES'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles2.default.field, _defineProperty({}, _styles2.default.active, active)),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles2.default.transportIcon, _styles2.default[transport], _styles.default.icon, isActual ? getIconClassBySeats(flight.seats.value) : _styles.default.black),
    dangerouslySetInnerHTML: {
      __html: getTransportIcon(transport)
    }
  }), flight && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("nobr", null, printFlightDate(flight)), ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames6.default)(_styles2.default.flightInfo, _defineProperty({}, _styles2.default.flightInfoCompact, compact))
  }, printFlightInformation(flight, isActual, placesTranslation, t))));
};
PureFlight.defaultProps = {
  isActual: true
};
var Flight = exports.Flight = (0, _react.memo)(PureFlight);
var hasBlockScroll = function hasBlockScroll(block) {
  return block.scrollHeight > block.clientHeight;
};
var scrollToEndDropdown = function scrollToEndDropdown(dropdownNode) {
  var _dropdownNode$getBoun = dropdownNode.getBoundingClientRect(),
    height = _dropdownNode$getBoun.height,
    y = _dropdownNode$getBoun.y;
  var scrollableBlock = R.call(R.pipe(function (blocks) {
    return R.isEmpty(blocks) ? null : blocks;
  }, R.when(Boolean, R.find(function (block) {
    return block.contains(dropdownNode);
  })), R.when(Boolean, function (block) {
    return hasBlockScroll(block) ? block : null;
  }), R.defaultTo(global.window)), (0, _helpers.getScrollableBlocks)());
  var topOffest = scrollableBlock === global.window ? global.window.scrollY : scrollableBlock.scrollTop;
  return global.window.innerHeight - y < height && scrollableBlock.scrollTo({
    top: topOffest + height,
    behavior: 'smooth'
  });
};
var Transport = function Transport(_ref2) {
  var className = _ref2.className,
    compact = _ref2.compact,
    flights = _ref2.flights,
    isActual = _ref2.isActual,
    isMobile = _ref2.isMobile,
    transport = _ref2.transport;
  var placesTranslation = (0, _pluralTranslations.usePluralPlacesTranslation)();
  var _useTranslation2 = (0, _reactI18next.useTranslation)('PLACES'),
    t = _useTranslation2.t;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeFlightIndex = _useState2[0],
    setActiveFlightIndex = _useState2[1];
  var activeFlight = flights[activeFlightIndex];
  return /*#__PURE__*/_react.default.createElement(_downshift.default, {
    onOpen: R.always
  }, function (_ref3) {
    var closeMenu = _ref3.closeMenu,
      isOpen = _ref3.isOpen,
      getToggleButtonProps = _ref3.getToggleButtonProps;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames6.default)(_styles2.default.dropdownContainer, className, _defineProperty({}, _styles2.default.isMobile, isMobile))
    }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      content: printFlightInformation(activeFlight, isActual, placesTranslation, t),
      placement: _Tooltip.PLACEMENTS.TOP,
      trigger: [_Tooltip.TRIGGERS.HOVER]
    }, /*#__PURE__*/_react.default.createElement("div", _extends({
      className: (0, _classnames6.default)(_styles2.default.fieldContainer, _defineProperty(_defineProperty({}, _styles2.default.active, isOpen), _styles2.default.hasDropdown, flights.length > 1))
    }, getToggleButtonProps({
      disabled: flights.length === 1
    })), /*#__PURE__*/_react.default.createElement(Flight, {
      compact: compact,
      flight: activeFlight,
      isActual: isActual,
      transport: transport
    }), flights.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.arrowIcon,
      dangerouslySetInnerHTML: {
        __html: _arrow.default
      }
    }))), isOpen && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.dropdown,
      ref: function ref(node) {
        return node && scrollToEndDropdown(node);
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles2.default.list
    }, mapperWithIndex(function (flight, index) {
      return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        content: printFlightInformation(flight, isActual, placesTranslation, t),
        placement: _Tooltip.PLACEMENTS.TOP,
        trigger: [_Tooltip.TRIGGERS.HOVER]
      }, /*#__PURE__*/_react.default.createElement(Flight, {
        active: flight === activeFlight,
        flight: flight,
        isActual: isActual,
        key: index,
        transport: transport,
        onClick: function onClick() {
          return setActiveFlightIndex(index), closeMenu();
        }
      }));
    }, flights))));
  });
};
Transport.propTypes = {
  className: _propTypes.default.oneOf([_styles2.default.inbound, _styles2.default.outbound]).isRequired,
  flights: _propTypes.default.arrayOf(_propTypes.default.shape({
    line: _propTypes.default.string,
    place: _propTypes.default.string,
    begin: _propTypes.default.string,
    portFr: _propTypes.default.string,
    portTo: _propTypes.default.string,
    seats: _propTypes.default.shape({
      value: _propTypes.default.string
    })
  })).isRequired,
  transport: _propTypes.default.string.isRequired,
  compact: _propTypes.default.bool,
  isMobile: _propTypes.default.bool
};
var EmptyTransportState = function EmptyTransportState(_ref4) {
  var children = _ref4.children,
    seats = _ref4.seats,
    transport = _ref4.transport,
    className = _ref4.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles2.default.noInfo, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles2.default.transportIcon, _styles2.default[transport], _styles.default.icon, seats ? getIconClassBySeats(seats.value) : _styles.default.yellow),
    dangerouslySetInnerHTML: {
      __html: getTransportIcon(transport)
    }
  }), children);
};
EmptyTransportState.propTypes = {
  seats: _propTypes.default.shape({
    value: _propTypes.default.string
  })
};
var computeAdditionalNights = function computeAdditionalNights(nights, nightsInHotel) {
  return R.call(R.ifElse(function (diff) {
    return diff > 0;
  }, function (diff) {
    return " + ".concat(diff);
  }, R.F), nights - nightsInHotel);
};
var isFilledFlights = function isFilledFlights(flights) {
  return !R.isEmpty(flights) && R.any(
  // and has one valid structure
  function (flight) {
    var isInvalidStructure = R.and(isDateWithoutTime(flight.begin) && isDateWithoutTime(flight.end), !(flight.portFr && flight.portTo));
    if (isInvalidStructure) {
      return false;
    }
    return true;
  }, flights);
};
var Transports = function Transports(_ref5) {
  var _flights$outbound$, _flights$inbound$;
  var compact = _ref5.compact,
    date = _ref5.date,
    flights = _ref5.flights,
    className = _ref5.className,
    isActual = _ref5.isActual,
    isMobile = _ref5.isMobile,
    nights = _ref5.nights,
    nightsInHotel = _ref5.nightsInHotel,
    transport = _ref5.transport;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(['RESULT_CARD', 'NIGHTS', 'TRANSPORTS']),
    t = _useTranslation3.t;
  var nightsTranslation = (0, _pluralTranslations.usePluralNightsTranslation)();
  var dateFrom = (0, _moment.default)(date, 'YYYY-MM-DD').startOf('day');
  var dateTo = dateFrom.clone().add(nights, 'days');
  var additionalNights = computeAdditionalNights(nights, nightsInHotel);
  var isExcludedTransport = transport === 'no';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames6.default)(_styles2.default.root, className, _defineProperty(_defineProperty({}, _styles2.default.compact, compact), _styles2.default.isMobile, isMobile))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.dates
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.date
  }, /*#__PURE__*/_react.default.createElement("span", null, dateFrom.format('DD MMM')), ' ', dateFrom.format('dd')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.duration
  }, nightsInHotel, ' ', compact ? t('SHORT_NIGHTS') : nightsTranslation(nightsInHotel), additionalNights && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('ADDITIONAL_NIGHTS_TOOLTIP_TEXT'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("span", null, additionalNights))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.date
  }, /*#__PURE__*/_react.default.createElement("span", null, dateTo.format('DD MMM')), ' ', dateTo.format('dd'))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.flights
  }, isFilledFlights(flights.outbound) ? /*#__PURE__*/_react.default.createElement(Transport, {
    className: _styles2.default.outbound,
    compact: compact,
    flights: flights.outbound,
    isActual: isActual,
    transport: transport,
    isMobile: isMobile
  }) : /*#__PURE__*/_react.default.createElement(EmptyTransportState, {
    className: _styles2.default.outbound,
    transport: transport,
    seats: (_flights$outbound$ = flights.outbound[0]) === null || _flights$outbound$ === void 0 ? void 0 : _flights$outbound$.seats
  }, compact ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: isExcludedTransport ? t('NO') : t('EMPTY_STATE_FOR_TRANSPORT_INFO'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.dots
  }, ". . .")) : isExcludedTransport ? t('NO') : t('EMPTY_STATE_FOR_TRANSPORT_INFO')), isFilledFlights(flights.inbound) ? /*#__PURE__*/_react.default.createElement(Transport, {
    className: _styles2.default.inbound,
    compact: compact,
    flights: flights.inbound,
    isActual: isActual,
    transport: transport
  }) : /*#__PURE__*/_react.default.createElement(EmptyTransportState, {
    className: _styles2.default.inbound,
    seats: (_flights$inbound$ = flights.inbound[0]) === null || _flights$inbound$ === void 0 ? void 0 : _flights$inbound$.seats,
    transport: transport
  }, compact ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: isExcludedTransport ? t('NO') : t('EMPTY_STATE_FOR_TRANSPORT_INFO'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles2.default.dots
  }, ". . .")) : isExcludedTransport ? t('NO') : t('EMPTY_STATE_FOR_TRANSPORT_INFO'))));
};
Transports.propTypes = {
  date: _propTypes.default.string.isRequired,
  nights: _propTypes.default.number.isRequired,
  nightsInHotel: _propTypes.default.number.isRequired,
  transport: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  compact: _propTypes.default.bool,
  flights: _propTypes.default.shape({
    outbound: _propTypes.default.array.isRequired,
    inbound: _propTypes.default.array.isRequired
  }),
  isActual: _propTypes.default.bool,
  isMobile: _propTypes.default.bool
};
Transports.defaultProps = {
  isActual: true
};
var _default = exports.default = (0, _react.memo)(Transports);